import { SkeletonRectangle } from 'shared/ui/Skeleton'
import { SkeletonMenuCard } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/SkeletonMenuCard/SkeletonMenuCard.tsx'
import styles from './styles.module.scss'

type ISkeletonMenuSectionProps = {
  items?: (number | 'auto')[]
  withTitle?: boolean
}

export const SkeletonMenuSection = ({ items = ['auto'], withTitle }: ISkeletonMenuSectionProps) => {
  return (
    <div className={styles.wrap}>
      {withTitle && (
        <div className={styles.title}>
          <SkeletonRectangle customWidth={'75px'} animated />
        </div>
      )}

      <div className={styles.container}>
        {items.map((item, i) => {
          return (
            <SkeletonMenuCard
              skeletonRectangleProps={{
                enableRandomWidth: item === 'auto',
                customWidth: typeof item === 'number' ? item : undefined,
              }}
              key={i}
            />
          )
        })}
      </div>
    </div>
  )
}
